import ErrorBlock from "../ErrorBlock";
import {useGearLaunchShop} from "../../../../hooks/useGearLaunchShop";
import BlockScroller from "../BlockScroller";
import BlockHead from "../_BlockHead";
import SchoolBlocksLoadingIndicator from "../../../utilities/SchoolBlocksLoadingIndicator";
import styles from "./styles/ShopBlock.module.scss"
import React from "react";
import ClickableLink from "../../../utilities/ClickableLink";
import {GearLaunchContactInfo, LoadingMessage} from "../../TerracedGridTheme/ShopTerrace/ShopTerrace";
import {IBlockComponentProps} from "../_Block";
import ShopOfferings from "../../TerracedGridTheme/ShopTerrace/ShopOfferings";
import {useStores} from "../../../../stores/useStores";

interface IShopBlockProps extends IBlockComponentProps {
    blockObj: IShopBlockObj
}

export default function ShopBlock(props: IShopBlockProps) {
    const {userStore} = useStores();
    const {data, isLoading} = useGearLaunchShop();

    try {
        const {blockType} = props.blockObj;

        return <BlockScroller blockRef={props.blockRef}
                              blockObj={props.blockObj}
                              htmlId={props.htmlId}
                              setShowExpandButton={props.setShowExpandButton}
                              outsideGrid={props.outsideGrid}>
            <ClickableLink aria-label="Click to view the full store"
                           title="Click to view the full store"
                           href={data?.storeUrl}>
                <BlockHead blockType={blockType} blockId={props.blockObj.id}>
                    <span style={{"position": "static"}}>
                        <div style={{"display": "inline-block", "fontSize": "1.4em", "marginRight": "0.3em"}}
                             className="fas fa-shop" role="img"
                             aria-hidden="true"/>
                    </span>
                    <span>{props.blockObj.title}</span>
                    <span style={{"position": "static"}}>
                        <div style={{"display": "inline-block", "fontSize": "1em", "marginLeft": "0.3em"}}
                             className="fas fa-external-link-alt" role="img"
                             aria-hidden="true"/>
                    </span>
                </BlockHead>
            </ClickableLink>
            {(props.blockObj?.status_code === 202 || data?.status === "IN_PROGRESS") ?
                <>{ userStore.isEditor ?
                    <span className={styles.contactInfo}><LoadingMessage className={styles.container} numItems={0}/></span>
                    : <div className={styles.infoMessage}>Please refresh the page to see the store.</div>
                }</>
                 :
                <>
                    {isLoading ? <div className={styles.loadingIndicator}>
                        <SchoolBlocksLoadingIndicator fill={"#E0E0E0"}/>
                    </div> : <ShopOfferings data={data?.items}
                                            className={styles.container}
                                            loadingClassName={styles.loadingClassName}/>
                    }
                    {userStore.isEditor && <span className={styles.contactInfo}><GearLaunchContactInfo/></span>}
                </>}
        </BlockScroller>
    } catch (error) {
        return <ErrorBlock blockObj={{errorMessage: error}}/>
    }
}
